import './hto-scheduled-later.scss';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
// actions
import localStorageHelper from '../../../../utils/localStorageHelper';
import { getSlots } from '../../../../actionCreators/hto';
// components
import { Form } from 'react-final-form';
import DayTimeCalendar from '../../../DayTimeCalendar/DayTimeCalendar';
import HTOCustomerDetails from '../../components/HTOCustomerDetails/HTOCustomerDetails';
import HTOPayment from '../HTOPayment/HTOPayment';
import Loader from '../../../Loader/Loader';

let formData;

function HTOScheduleLater(props) {
    const [initialValues, setInitialValues] = useState({});
    useEffect(() => {
        const data = localStorageHelper.getItem('htoAddress');
        props.getSlots(data.bookLater.postcode);
    }, []);

    const prevList = useRef(props.list);
    useEffect(() => {
        if (props.list !== prevList && props.list && props.list.length) {
            // Assign available slot
            const slot = props.list.find(slot => slot.slots.length);
            const data = localStorageHelper.getItem('htoAddress');
            setInitialValues({ date: slot.date, slotName: `${slot.slots[0].slot_name}`, slot: `${slot.slots[0].slot_id}`, addressType: 'home', paymentType: 'online', addressline1: data && data.formattedAddress });
        }
    }, [props.list]);

    const prevCartData = useRef(props.cartData);
    useEffect(() => {
        if (props.cartData !== prevCartData && props.cartData && formData) {
            props.placeOrder(formData.paymentType, formData, props.cartData.totals.total);
            formData = null;
        }
    }, [props.cartData]);

    // const submit = data => props.placeOrder(data.paymentType, data);

    const submit = data => {
        formData = data;
        const appointmentType = 'bookLater';
        localStorageHelper.setItem('htoBookLaterData', data);
        props.scheduleOrUpdate(appointmentType, data);
    };

    if (!props.list || props.list.length === 0) return <div className="hto-loader-container">{props.list && props.list.length === 0 ? <div className="no-slots text-center fs30 fsp30"><span>SORRY</span><div className="display-block fs13 fsp13" dangerouslySetInnerHTML={{ __html: props.htoConfig.messages.noSlots }} /></div> : <Loader />}</div>;

    return (
        <Form
            onSubmit={submit}
            initialValues={initialValues}
            mutators={{
                setSlotName: (args, state, utils) => {
                    utils.changeValue(state, 'slotName', () => args[0]);
                },
                // expect (field, value) args from the mutator
                setValue: ([field, value], state, { changeValue }) => {
                    changeValue(state, field, () => value);
                }
            }}
        >
            {({ handleSubmit, values, form }) => {
                return (
                    <form className="hto-scheduled-later" onSubmit={handleSubmit} noValidate>
                        <DayTimeCalendar list={props.list} values={values} mutators={form.mutators} />
                        <HTOCustomerDetails values={values} />
                        <HTOPayment values={values} placeOrder={props.placeOrder} mutators={form.mutators} navTo={props.navTo} />
                    </form>
                );
            }}
        </Form>
    );
}

const mapStateToProps = state => {
    return {
        list: state.hto.slotDetails && state.hto.slotDetails.slot_list,
        cartData: state.cart.cartData.result,
        loadingCart: state.cart.isCartLoader,
        loadingSlotDetails: state.hto.loadingSlotDetails,
        htoConfig: state.hto.htoConfig
    };
};

const mapDispatchToProps = dispatch => ({
    getSlots: pincode => dispatch(getSlots(pincode))
});

export default connect(mapStateToProps, mapDispatchToProps)(HTOScheduleLater);
